import { render, staticRenderFns } from "./InviteUserModal.vue?vue&type=template&id=54c382aa"
import script from "./InviteUserModal.vue.ts?vue&type=script&lang=ts&external"
export * from "./InviteUserModal.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports